// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18bfJ","select":"styles_select__2jSq5"};